var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.879,
    cy: 287.879,
    r: 287.879,
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134.682,
    y: 126.76,
    width: 316.899,
    height: 316.899,
    fill: "url(#pattern0_993_592)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_993_592",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_993_592",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_993_592",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAIhSURBVFiFxZcxaBRBFIa/t3u74Y4QCBaCSKKghZ2KFjZRC5tUYgyksDmwEiTIEgurKxJEuFiIRALaiFaClXaCTUCCiFpbRdOJSkzI6c3dPosjwWxyd2/jnPm72ffP/B8zb5dZIaMayXCAzAnpOZBStt5BH2JmTyiT+2Hwq1BJLZOC7IMQfS7oaM7wTdUpnHGsPlXGw9wANZJhkJO7Cc5owjH0xAKxBSAkGPQQngti2xF4VleIXgN0hfAJELUWDNbbQDxSKtvyCh4BjirXB2DltWNgUkkPZA2OtdPAYq8AYkc8H7GvHFO5Z50kfw/qTB2H9P2/UAgsKywAP3eqN9DpEne/bIx97gAACgeBiXb1AuEDYBPgf7wFHbXnANYjWBDkpqJ1i1mQWNEZ4LwvgE8R1TdGL8p46BhatnitAOU6yWWgYTG71kep3+LN0wPS3ZJfxh2QxxH9ZeslQ6kEjtV54KonAD3kWDlVJ2la3A3WYtBjlk2z9sAIBIvdbS0pivXErAC/FF4FSM1iTtGiwAWgzwuAIvf7qE5ZvBv6TTIjcMsLgKBjjuQbiNriNVL0is8eOKxwG4z5gO8eWBJ4COLaGRQdBUaM6+UDUORZTHW6k8dx46MS9AZASK85kiMddiBQ9GzecDMASEnhYr4esGnP7wNbAJqkP3od2CT43hagyOwS8K6H+W+L3PncFgCgSeGSwkvQnX4wdildV3jRQMeylT9duaHdv1IJvgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkd);
export default __webpack_public_path__ + "static/media/bkd.f338cf338e5e0b84938fc8bfb28c6e89.svg";
export { ForwardRef as ReactComponent };